import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";

import Forest from "../../../../assets/images/Scents/Forest.svg";
import Fresh from "../../../../assets/images/Scents/Fresh.svg";
import Glow from "../../../../assets/images/Scents/Glow.svg";
import Oasis from "../../../../assets/images/Scents/Oasis.svg";
import Soft from "../../../../assets/images/Scents/Soft.svg";
import "./homeDetailsCardsListComponent.scss";
import HomeDetailsCardComponent from "../card/HomeDetailsCardComponent";

const cardsData = [
  {
    Image: Forest,
    Description: {
      Title: "Forest",
      Subtitle: "חוויה שמרגישה כמו לטייל בין נגיעות טבע קסומות",
      Text: "Forest מזמין אתכם להיכנס לעולם שבו כל שאיפה היא מסע חושי: תחילה תרגישו רעננות מתוקה שמרגישה כמו קרן שמש חמה ביום קיצי, שמלטפת את החושים ברוך. בהמשך, הניחוח מתעמק לעולם עדין ונעים, שמעלה זכרונות של פריחה טבעית ואוויר צח לאחר גשם קל, ומסתיים בתחושה חמימה ונוגה שמזכירה ערב רגוע ביער קסום.",
    },
  },
  {
    Image: Fresh,
    Description: {
      Title: "Fresh",
      Subtitle: "מפגש קסום בין רעננות מדברית לחמימות נצחית",
      Text: "הריח נפתח בתחושה שטופת שמש ומלאת חיים, כמו משב רוח צלול שמביא עמו לחישה של מרחבים פתוחים, ממשיך בעדינות מלטפת שמזכירה פריחה נדירה בין חולות זהובים, ונוחת בחמימות עמוקה ומזמינה שמרגישה כמו חיבוק רך תחת שמי מדבר אינסופיים.",
    },
  },
  {
    Image: Glow,
    Description: {
      Title: "Glow",
      Subtitle: "מפגש קסום בין רעננות מדברית לחמימות נצחית",
      Text: "הריח נפתח בתחושה שטופת שמש ומלאת חיים, כמו משב רוח צלול שמביא עמו לחישה של מרחבים פתוחים, ממשיך בעדינות מלטפת שמזכירה פריחה נדירה בין חולות זהובים, ונוחת בחמימות עמוקה ומזמינה שמרגישה כמו חיבוק רך תחת שמי מדבר אינסופיים.",
    },
  },
  {
    Image: Oasis,
    Description: {
      Title: "Oasis",
      Subtitle: "מפגש קסום בין רעננות מדברית לחמימות נצחית",
      Text: "הריח נפתח בתחושה שטופת שמש ומלאת חיים, כמו משב רוח צלול שמביא עמו לחישה של מרחבים פתוחים, ממשיך בעדינות מלטפת שמזכירה פריחה נדירה בין חולות זהובים, ונוחת בחמימות עמוקה ומזמינה שמרגישה כמו חיבוק רך תחת שמי מדבר אינסופיים.",
    },
  },
  {
    Image: Soft,
    Description: {
      Title: "Soft",
      Subtitle: "חיבוק עדין של רכות ואור",
      Text: "הריח נפתח בתחושה זוהרת וקלילה שמזכירה קרני שמש חמימות ביום אביבי, ממשיך בעדינות מלטפת שמעוררת זכרונות של פריחה רכה מתחת לשמיים פתוחים, ונרדם בתוך חמימות נעימה ועוטפת שמרגישה כמו שמיכה רכה בסוף יום ארוך.",
    },
  },
];

const HomeDetailsCardsListComponent = () => {
  return (
    <div className="homeDetailsCardsListGalleryContainer">
      <h1>משפחות הריח שלנו</h1>
      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        // navigation={true}
        modules={[Pagination, Autoplay, Navigation]}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
        }}>
        {cardsData.map((card, index) => (
          <SwiperSlide key={index}>
            <HomeDetailsCardComponent card={card} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomeDetailsCardsListComponent;
